var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-5 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m65.86,25.94L23.11,14.77c-1.35-.35-2.73.46-3.08,1.8l-3.99,15.26c-.35,1.35.46,2.73,1.8,3.08l33.37,8.71c1.33.35,2.7-.44,3.07-1.76l1.4-5.01c.19-.69.67-1.26,1.31-1.58l9.36-4.63c2.09-1.04,1.78-4.11-.48-4.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.74,
    cy: 55.32,
    r: 4.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m17.73,55.32h7.17c1.03,0,1.96-.63,2.34-1.58l5.8-14.47"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(0 -5.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.5,
    y: 0
  }, "ame"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 24.41,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.65,
    y: 0
  }, "a - "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 40.88,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.86,
    y: 0
  }, "n"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/__Camera - On.39d3d46f8e967e8b83b35c7dea15202c.svg";
export { ForwardRef as ReactComponent };